import {
  type ExperimentalFeature,
  type FeatureCategory,
  type FeatureSubfeature,
} from '@luxuryescapes/contract-svc-promo';

export type PromoFeatureIndicator = FeatureSubfeature & {
  category: FeatureCategory;
  depth: number;
  parentKeys: ReadonlyArray<string>;
};

type FeatureEntry = ExperimentalFeature | FeatureSubfeature;

function getSubfeatures(feature: FeatureEntry): ReadonlyArray<FeatureSubfeature> {
  return feature.subfeatures ?? [];
}

/** Flattens the service's nested catalogue while retaining its display hierarchy. */
export function getPromoFeatureIndicators(
  features: ReadonlyArray<ExperimentalFeature>,
): ReadonlyArray<PromoFeatureIndicator> {
  const indicators: Array<PromoFeatureIndicator> = [];

  function visit(feature: FeatureEntry, category: FeatureCategory, depth: number, parentKeys: ReadonlyArray<string>) {
    indicators.push({ ...feature, category, depth, parentKeys });

    getSubfeatures(feature).forEach((subfeature) => {
      visit(subfeature, category, depth + 1, [...parentKeys, feature.key]);
    });
  }

  features.forEach((feature) => visit(feature, feature.category, 0, []));
  return indicators;
}

export function findPromoFeatureIndicator(
  features: ReadonlyArray<ExperimentalFeature>,
  featureKey: string,
): PromoFeatureIndicator | undefined {
  return getPromoFeatureIndicators(features).find((feature) => feature.key === featureKey);
}

export function getOptInFeatureKeys(features: ReadonlyArray<ExperimentalFeature>): ReadonlySet<string> {
  return new Set(getPromoFeatureIndicators(features).flatMap((feature) => (feature.canOptIn ? [feature.key] : [])));
}
